module.exports = __webpack_public_path__ + "media/images/adaptable-2db9bbfecc238e6d5356a5d7b39f2ee6.png";